import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const LayoutsContext = createContext({
    layouts: new Map(),
});
export function LayoutsProvider({ layouts, children }) {
    const layoutsMap = new Map();
    for (const layout of layouts) {
        layoutsMap.set(layout.name, layout);
    }
    return (_jsx(LayoutsContext.Provider, { value: { layouts: layoutsMap }, children: children }));
}
export function useLayouts() {
    return useContext(LayoutsContext);
}
export function useLayoutDef(name) {
    const { layouts } = useLayouts();
    return layouts.get(name);
}
//# sourceMappingURL=LayoutsContext.js.map